var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGithub = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 27 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#github_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#24292F",
  fillRule: "evenodd",
  d: "M13.46 0C6.017 0 0 5.958 0 13.33c0 5.892 3.855 10.88 9.203 12.645.67.133.914-.287.914-.64 0-.309-.022-1.368-.022-2.472-3.744.795-4.524-1.589-4.524-1.589-.602-1.545-1.493-1.942-1.493-1.942-1.226-.816.09-.816.09-.816 1.358.088 2.072 1.368 2.072 1.368 1.203 2.03 3.142 1.457 3.922 1.103.11-.86.468-1.456.847-1.787-2.987-.31-6.129-1.457-6.129-6.577 0-1.456.535-2.648 1.382-3.575-.134-.33-.602-1.7.134-3.53 0 0 1.136-.354 3.699 1.367a13.2 13.2 0 0 1 3.365-.441c1.136 0 2.295.155 3.365.441 2.562-1.721 3.699-1.368 3.699-1.368.735 1.832.267 3.2.133 3.531.87.927 1.382 2.119 1.382 3.575 0 5.12-3.142 6.246-6.15 6.577.49.42.913 1.213.913 2.472 0 1.787-.022 3.222-.022 3.663 0 .353.245.773.914.64 5.348-1.766 9.203-6.753 9.203-12.645C26.92 5.958 20.88 0 13.46 0",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "github_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h27v26H0z"
})))));
export default SvgGithub;